import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { GlobalConversationSeparator } from 'utils/urls';

export const ProjectConversationPageResponsive = () => {
  const { chatId, entityType, projectId } =
    useParams<{ chatId: string; entityType: string; projectId: string }>();
  const { push } = useHistory();
  const finalChatId = [entityType, chatId].join(GlobalConversationSeparator);

  useEffect(() => {
    push(`/projects/${projectId}/chat/${finalChatId}`);
  }, [finalChatId, projectId, push]);

  return <div />;
};
